import React from "react";
import Icon from "../../components/Icon";

/**
 * Bloco de introdução em linguagem simples do painel de API: texto à esquerda
 * (largura de leitura confortável) e um mini-diagrama animado opcional à direita.
 * Portado do brindeme_sistema (pages/Integration/tabs/PanelIntro).
 *
 * O link da documentação NÃO vive aqui (ao contrário do original): virou uma
 * faixa própria no topo da página — ver DocsBanner.
 */
export const PanelIntro = ({ icon, iconBg, iconFg, title, children, art }) => (
    <div className="panel-intro">
        <div className="panel-intro__cols">
            <div className="panel-intro__main">
                <div className="panel-intro__head">
                    <span className="panel-intro__icon" style={{ background: iconBg, color: iconFg }}>
                        {icon}
                    </span>
                    <h2>{title}</h2>
                </div>
                <div className="panel-intro__body">{children}</div>
            </div>

            {art && <div className="panel-intro__art">{art}</div>}
        </div>

        <p className="panel-intro__note">
            <Icon name="alert" size={16} strokeWidth={1.8} />
            <span>
                <strong>Recurso técnico.</strong> Para configurar, conte com um desenvolvedor da sua
                equipe, um freelancer ou uma agência.
            </span>
        </p>
    </div>
);

export default PanelIntro;
